export class Wizard {
  step: number;
  totalStep: number;
  loginName:string;
  password:string;
  cfmPassword:string;
  dbAddress:string;
  dbUSer:string;
  dbPassword:string;
  dbName:string;
  emailDomain:string;
  emailUser:string;
  emailPassword:string;
  cfmEmailPassword:string;
  baseMailFolder:string;
  runasuser:string;
  dependency:string[];
  
  constructor() {
    this.step = 1;
    this.totalStep = 4;
    this.loginName = "";
    this.password = "";
    this.cfmPassword = "";
    this.dbAddress="";
    this.dbUSer="";
    this.dbPassword="";
    this.dbName="";
    this.emailDomain="";
    this.emailUser="";
    this.emailPassword="";
    this.cfmEmailPassword="";
    
  }
}
